/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'

icon.register({
  'equip': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M916.48 931.84H112.64a15.36 15.36 0 01-15.36-15.36V716.8a15.36 15.36 0 0115.36-15.36h803.84a15.36 15.36 0 0115.36 15.36v199.68a15.36 15.36 0 01-15.36 15.36zm-115.2-168.96H325.12a48.64 48.64 0 000 97.28h476.16a48.64 48.64 0 000-97.28zm115.2-133.12H112.64a15.36 15.36 0 01-15.36-15.36V414.72a15.36 15.36 0 0115.36-15.36h803.84a15.36 15.36 0 0115.36 15.36V614.4a15.36 15.36 0 01-15.36 15.36zm-115.2-163.84H586.24a48.64 48.64 0 000 97.28h215.04a48.64 48.64 0 000-97.28zm115.2-138.24H112.64a15.36 15.36 0 01-15.36-15.36V112.64a15.36 15.36 0 0115.36-15.36h803.84a15.36 15.36 0 0115.36 15.36v199.68a15.36 15.36 0 01-15.36 15.36zm-115.2-158.72H478.72a48.64 48.64 0 000 97.28h322.56a48.64 48.64 0 000-97.28z"/>'
  }
})
